import { fetchJsonWithAuth } from './authApi';
import { AUTH_URL } from './apiConfig';

const ADMIN_PATH = '/admin/email-templates';
const RUNTIME_PATH = '/email-templates';

function dataOf(json) { return json?.data ?? json; }

export async function getEmailTemplates({ offset = 0, limit = 20, search = '', module = '', action = '', active } = {}) {
  const params = new URLSearchParams({ offset: String(offset), limit: String(limit) });
  if (search) params.set('search', search);
  if (module) params.set('module', module);
  if (action) params.set('action', action);
  if (active !== undefined) params.set('active', String(active));
  const payload = dataOf(await fetchJsonWithAuth(AUTH_URL, `${ADMIN_PATH}?${params}`)) ?? {};
  return { items: Array.isArray(payload.items) ? payload.items : [], totalCount: Number(payload.totalCount ?? 0) };
}

export async function getEmailTemplate(id) {
  return dataOf(await fetchJsonWithAuth(AUTH_URL, `${ADMIN_PATH}/${encodeURIComponent(id)}`));
}

export async function createEmailTemplate(payload) {
  return fetchJsonWithAuth(AUTH_URL, ADMIN_PATH, { method: 'POST', body: JSON.stringify(payload) });
}

export async function updateEmailTemplate(id, payload) {
  return fetchJsonWithAuth(AUTH_URL, `${ADMIN_PATH}/${encodeURIComponent(id)}`, { method: 'PUT', body: JSON.stringify(payload) });
}

export async function deleteEmailTemplate(id) {
  return fetchJsonWithAuth(AUTH_URL, `${ADMIN_PATH}/${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export async function getRuntimeEmailTemplates({ module = '', action = '' } = {}) {
  const params = new URLSearchParams();
  if (module) params.set('module', module);
  if (action) params.set('action', action);
  const suffix = params.toString() ? `?${params}` : '';
  const payload = dataOf(await fetchJsonWithAuth(AUTH_URL, `${RUNTIME_PATH}${suffix}`));
  return Array.isArray(payload) ? payload : [];
}

export async function getRuntimeEmailTemplate(id) {
  return dataOf(await fetchJsonWithAuth(AUTH_URL, `${RUNTIME_PATH}/${encodeURIComponent(id)}`));
}

export async function getSignatures({ offset = 0, limit = 20, search = '' } = {}) {
  const params = new URLSearchParams({ offset: String(offset), limit: String(limit), sortBy: 'new', searchValue: search });
  const payload = dataOf(await fetchJsonWithAuth(AUTH_URL, `/signature/homePage?${params}`)) ?? {};
  const items = Array.isArray(payload.data) ? payload.data.map((item) => ({ ...item, isActive: item.isActive ?? item.status ?? false })) : [];
  return { items, totalCount: Number(payload.totalCount ?? items.length) };
}

export async function getSignature(id) {
  return dataOf(await fetchJsonWithAuth(AUTH_URL, `/signature/editPreview?signatureId=${encodeURIComponent(id)}`));
}

export async function createSignature(payload) {
  return fetchJsonWithAuth(AUTH_URL, '/signature/add', { method: 'POST', body: JSON.stringify(payload) });
}

export async function updateSignature(payload) {
  return fetchJsonWithAuth(AUTH_URL, '/signature/edit', { method: 'PUT', body: JSON.stringify(payload) });
}

export async function deleteSignature(id) {
  return fetchJsonWithAuth(AUTH_URL, `/signature/delete?signatureId=${encodeURIComponent(id)}`, { method: 'DELETE' });
}

export async function updateSignatureStatus(id, status) {
  return fetchJsonWithAuth(AUTH_URL, `/signature/statusUpdate?signatureId=${encodeURIComponent(id)}&status=${status}`, { method: 'PUT' });
}
